export enum ReduxSliceName {
  Permission = "permission",
}
